import { Component } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Echarpes from "@/pages/Echarpes";
import Stock from "@/pages/Stock";
import Admin from "@/pages/Admin";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error) {
    console.error("App error:", error);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-white px-6 text-center">
          <div>
            <p className="eyebrow mb-4">ZULIANY</p>
            <p className="font-serif text-3xl text-[#0A0A0B]">Une erreur est survenue</p>
            <button
              data-testid="error-reload-button"
              className="mt-8 border border-[#0A0A0B]/40 px-8 py-3 font-mono text-xs uppercase tracking-[0.25em] text-[#0A0A0B] transition-colors hover:bg-[#0A0A0B] hover:text-white"
              onClick={() => window.location.reload()}
            >
              Recharger
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/echarpes" element={<Echarpes />} />
          <Route path="/stock" element={<Stock />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
